import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Alert } from 'react-bootstrap';
import apiClient from '../apiClient';

function CommunicationDashboardDebug() {
  const [rawResponse, setRawResponse] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCommunications();
  }, []);

  const fetchCommunications = async () => {
    try {
      setLoading(true);
      console.log('Fetching from /communications/all...');
      
      const response = await apiClient.get('/communications/all');
      
      console.log('Raw response:', response);
      console.log('Response data:', response.data);
      console.log('Response data type:', typeof response.data);
      console.log('Response data keys:', response.data ? Object.keys(response.data) : 'null');
      
      setRawResponse(response.data);
      
    } catch (err) {
      console.error('Error fetching communications:', err);
      setError(err.message || 'Failed to fetch communications');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <Alert variant="danger">Error: {error}</Alert>;

  return (
    <Container>
      <Row>
        <Col>
          <h1>Communication Dashboard Debug</h1>
          
          <Card className="mt-4">
            <Card.Header>
              <h3>Raw API Response</h3>
            </Card.Header>
            <Card.Body>
              <pre style={{ backgroundColor: '#f5f5f5', padding: '15px', borderRadius: '5px' }}>
                {JSON.stringify(rawResponse, null, 2)}
              </pre>
            </Card.Body>
          </Card>
          
          <Card className="mt-4">
            <Card.Header>
              <h3>Response Analysis</h3>
            </Card.Header>
            <Card.Body>
              <p><strong>Type:</strong> {typeof rawResponse}</p>
              <p><strong>Is Array:</strong> {Array.isArray(rawResponse) ? 'Yes' : 'No'}</p>
              {rawResponse && typeof rawResponse === 'object' && (
                <>
                  <p><strong>Keys:</strong> {Object.keys(rawResponse).join(', ')}</p>
                  {rawResponse.communications && (
                    <>
                      <p><strong>Communications Type:</strong> {typeof rawResponse.communications}</p>
                      <p><strong>Communications Is Array:</strong> {Array.isArray(rawResponse.communications) ? 'Yes' : 'No'}</p>
                      <p><strong>Communications Length:</strong> {Array.isArray(rawResponse.communications) ? rawResponse.communications.length : 'N/A'}</p>
                    </>
                  )}
                </>
              )}
              {Array.isArray(rawResponse) && (
                <p><strong>Array Length:</strong> {rawResponse.length}</p>
              )}
            </Card.Body>
          </Card>
          
          <Card className="mt-4">
            <Card.Header>
              <h3>First Communication (if any)</h3>
            </Card.Header>
            <Card.Body>
              <pre style={{ backgroundColor: '#f5f5f5', padding: '15px', borderRadius: '5px' }}>
                {(() => {
                  const comms = Array.isArray(rawResponse) ? rawResponse : 
                               (rawResponse?.communications || []);
                  return comms.length > 0 ? 
                    JSON.stringify(comms[0], null, 2) : 
                    'No communications found';
                })()}
              </pre>
            </Card.Body>
          </Card>
          
          <Button 
            variant="primary" 
            onClick={fetchCommunications}
            className="mt-3"
          >
            Refresh
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default CommunicationDashboardDebug;